import * as Yup from "yup"
import { integration } from "./integration"


const {
  formField: { 
    integrationName,
    description,
    version,
  }
} = integration

export const integrationsValidations = Yup.object().shape({
  [integrationName.name]: Yup
    .string()
    .required(integrationName.errorMsg)
    .max(50),
  [description.name]: Yup
    .string()
    .max(500),
  [version.name]: Yup
    .string()
    .required(version.errorMsg)
    .max(20)
})